import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import Select from 'react-select';

const AddContentType = ({language, contentModels, isVisible, setIsVisible}) => {
    //const [addContentTypeShow, setAddContentTypeShow] = useState(isVisible)
    const [contentTypeName, setContentTypeName] = useState('')
    const [contentTypeUrl, setContentTypeUrl] = useState('')
    const [contentModelId, setContentModelId] = useState(0)
    const history = useHistory();

    const filter = contentModels.map((contentModel) => {
        return {value: contentModel.id, label: contentModel.modelName};
    })

    const handleClose = async e => {
        e.preventDefault();
        setContentTypeName('')
        setContentTypeUrl('')
        setContentModelId(0)
        setIsVisible(isVisible ? false : true)
    }

    const cleanChar = (string) => {
        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
        const p = new RegExp(a.split('').join('|'), 'g')
    
        const res = string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/æ/g, 'ae')
        .replace(/ø/g, 'oe')
        .replace(/å/g, 'aa')
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w-]+/g, '') // Remove all non-word characters
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text

        
        setContentTypeUrl(res)
    }

    useEffect(() => {
        const slugify = (string) => {
            cleanChar(string)
        }
        slugify(contentTypeName)
    },[contentTypeName,contentTypeUrl])
      
    const selectContentModelId = (option) => {
        setContentModelId(option.value)
    }

    const postContentType = async () => {

        var graphql = JSON.stringify({
            query: `mutation ($contentModelId: Long, $contentTypeName: String, $contentTypeUrl: String){
                        addContentType(contentModelId:$contentModelId, contentTypeName:$contentTypeName, contentTypeUrl:$contentTypeUrl) {
                            id
                        }
                    }`,
            variables: {
                "contentModelId": contentModelId
                ,"contentTypeName": contentTypeName
                ,"contentTypeUrl": contentTypeUrl
            }
            
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {
            var resultData = JSON.parse(result).data
            if(resultData.addContentType){
                history.push(`/content/${resultData.addContentType.id}`)
            }
            return 
        })
        .catch(error => console.log('error', error))
        const data = await res
        
        return data

    }

    const handleSave = async e => {
        e.preventDefault();
        var error = false
        if(contentTypeName === ""){
            error = true
        }
        if(contentModelId === 0){
            error = true
        }
        if(!error){
            await postContentType()
        }
    }

    return (
        <>
        {(isVisible) && <div id="cc_overlay"></div>}
        <div id="cc_editarticle" className={isVisible ? '' : 'hidden'} >
            <div className="close-container">
                <span className="result_response"></span>
                <button onClick={handleClose}><i className="sprite-icon icon-close"></i></button>
            </div>
            <h3>{language.value === 'DA' ? 'Tilføj nyt Indhold' : 'Add new Content'}</h3>
            <div id="cc_article_container">
                <div id="articletype_list">
                    <label className="input_label">
                        <span>Type</span>
                        <Select className="contentModelSelect" classNamePrefix="contentModelSelect" options={filter} onChange={selectContentModelId} placeholder={language.value === 'DA' ? 'Indholds type' : 'Content type'} />
                    </label>
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Navn' : 'Name'}</span>
                        <input type="text" name="contentTypeName" value={contentTypeName} onChange={ e => setContentTypeName(e.target.value)} autoComplete="off"/>
                    </label>
                    <label className="input_label">
                        <span>Url</span>
                    </label>
                    <small>{contentTypeUrl}</small>
                    <span><input type="hidden" name="contentTypeUrl" value={contentTypeUrl} onChange={e => cleanChar(e.target.value)} /></span>
                </div>
                
                <div className="align_right">
                    <button onClick={handleSave} className="cc-btn blue-gradient">{language.value === 'DA' ? 'GEM' : 'SAVE'}</button>
                </div>
            </div>
        </div>
        </>
    )
}

export default AddContentType
